// Helpers de modalidad Venta/Arriendo (Fase 2). El backend siempre devuelve
// `operations`/`prices` (normalizados en lectura), pero mantenemos fallback a
// los campos legacy `operation`/`price` por robustez.

export function getOperations(p) {
  if (Array.isArray(p?.operations) && p.operations.length) return p.operations;
  return p?.operation ? [p.operation] : [];
}

export function isDual(p) {
  const ops = getOperations(p);
  return ops.includes('venta') && ops.includes('arriendo');
}

export function getPrices(p) {
  const ops = getOperations(p);
  const prices = p?.prices || {};
  const venta = prices.venta ?? (p?.operation === 'venta' ? p?.price : undefined);
  const arriendo = prices.arriendo ?? (p?.operation === 'arriendo' ? p?.price : undefined);
  return {
    venta: ops.includes('venta') ? venta : undefined,
    arriendo: ops.includes('arriendo') ? arriendo : undefined,
  };
}

export function operationLabel(p) {
  if (isDual(p)) return 'Venta y Arriendo';
  return getOperations(p).includes('arriendo') ? 'Arriendo' : 'Venta';
}

// ── Cargador de vehículo eléctrico ──────────────────────────────────────────
export const EV_CHARGER_LABELS = {
  private: 'Cargador privado',
  communal: 'Cargador disponible en conjunto/edificio',
  none: 'No cuenta con cargador para vehículo eléctrico',
};

// Devuelve la etiqueta a mostrar, o null cuando no debe mostrarse
// (unspecified o ausente → no mostrar nada).
export function evChargerLabel(p) {
  const v = p?.ev_charger;
  return EV_CHARGER_LABELS[v] || null;
}
